module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_0_1@3x.31d6d0e2.png";